/** Display name for the signed-in user (individual or corporate profile). */
export function getAuthUserDisplayName(user) {
  const profile = user?.individualProfile || user?.corporateProfile || {};
  const name = [profile.firstName, profile.lastName].filter(Boolean).join(" ");

  return name || profile.companyName || user?.email?.split("@")?.[0] || "";
}

export function getAuthUserAvatarUrl(user) {
  return String(user?.avatarUrl ?? "").trim();
}

export function isAuthUserEmailVerified(user) {
  return Boolean(user?.emailVerifiedAt);
}

export function getAuthUserInitials(user) {
  const name = getAuthUserDisplayName(user);
  if (!name) return "?";
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
}
